import React from "react";
import styles from "./PaintingsSection.module.scss";
import Title from "components/title/Title";
import ArtworkCard from "components/cards/artworkCard/ArtworkCard";
import { paintings } from "mockdata/paintings";

const PaintingsSection = () => {
  return (
    <div className={styles.paintingsSectionContainer}>
      <div className="container">
        <Title text={"Paintings"} bottomStrokeWidth={"53%"} />
        <div className={styles.seeAllWrapper}>
          <div className={styles.seeAll}>See All Paintings</div>
        </div>
        <div className={styles.cardGrid}>
          {paintings.map((painting) => {
            return <ArtworkCard item={painting} key={painting.id} />;
          })}
        </div>
        <div className={styles.seeAllCentered}>See All Paintings</div>
      </div>
    </div>
  );
};

export default PaintingsSection;
